const zh = {
  meta: { title: "Trollfossjakten · 巨魔瀑布探险 — 在 Lavangen 与 Årstein 之间寻找 84 个巨魔" },
  sound: { mute: "关闭巨魔音效", unmute: "开启巨魔音效" },
  nav: { map: "地图", trolls: "巨魔", seasons: "四季", pricing: "价格", faq: "常见问题", getApp: "下载应用", hosts: "成为接待点" },
  tagline: "61 个巨魔永久免费。其余的正在躲藏——带上通行证吧。",
  store: { soon: "应用即将走出森林", soonBody: "应用商店链接将在上线时开放，敬请期待。", appStore: "App Store", playStore: "Google Play", download: "下载于", getIt: "下载于" },
  hero: {
    kicker: "Lavangen · Gratangen · 挪威特罗姆斯",
    title: "在 Lavangen 与 Årstein 之间寻找 84 个巨魔。",
    pitch: "9 座瀑布、84 个手绘巨魔、一条峡湾公路。免费开始——冬天可以滑雪，夏天可以滑轮滑。",
    cta: "开始探险",
    ctaMap: "查看完整地图",
    stats: [["84", "个巨魔"], ["9", "座瀑布"], ["61", "个永久免费"], ["4", "个季节"]],
    stamp: "免费开始",
    photoNote: "瀑布 · 峡湾 · 巨魔",
  },
  what: {
    kicker: "什么是 Trollfossjakten？",
    title: "沿着一条真实峡湾公路展开的民间传说寻宝之旅。",
    cols: [
      { title: "沿路探索", body: "从 Lavangen 到 Årstein，步行、骑车、滑雪或滑轮滑皆可。九座瀑布为你指路。" },
      { title: "捕捉巨魔", body: "84 个手绘巨魔藏在溪边、海岸和小店里。找到它们，捕捉它们，填满你的日志。" },
      { title: "赚取巨魔克朗", body: "收集应用内货币，在沿途的合作小屋、咖啡馆和商店里使用。" },
    ],
    callout: "无需注册。打开应用，开始狩猎。",
  },
  map: {
    kicker: "步道地图",
    title: "每一个巨魔，都标在地图上。",
    body: "84 个巨魔分布在从 Lavangen 到 Årstein 的公路沿线，途经 Røkenes、Hestnes 和 Sørsida。点击图钉认识它们——然后在应用里真正捕捉它们。",
    chips: { all: "全部", common: "普通", rare: "稀有", epic: "史诗", legendary: "传说", festivals: "节日", merchants: "商家" },
    showing: "个巨魔",
    start: "Lavangen · 起点",
    finish: "Årstein · 终点",
    waterfall: "瀑布",
    catchIt: "在应用中捕捉",
    close: "关闭",
    recenter: "回到步道",
  },
  xp: {
    kicker: "经验值与游戏系统",
    title: "狩猎、升级，再小小炫耀一下。",
    body: "每次捕捉都能获得经验值。越稀有的巨魔奖励越多——有些只在特定日子出现。",
    cards: {
      xp: { title: "各稀有度经验值", body: "藏得越深，奖励越高。" },
      ach: { title: "12 项成就", body: "每项最高 5,000 经验值。先来几个：", more: "+ 另外 6 项等你在应用中发现" },
      items: { title: "物品与套装", body: "收集巨魔留下的小玩意儿，集齐整套。", list: ["珍珠", "符文", "华夫饼", "海盗金币"] },
      kroner: { title: "巨魔克朗", body: "通过邀请好友、每日转盘和商家巨魔获得，可在合作小屋和商家使用。" },
    },
    achievements: [["首次捕获", 20], ["节日粉丝", 500], ["溪流之王", 800], ["孤胆战士", 1000], ["传说猎人", 1500], ["四季轮回", 5000]],
    extras: [
      { title: "连续天数 + 连续护盾", body: "每天狩猎，积累连续天数。护盾每周可保住一次错过的日子。" },
      { title: "每日转盘", body: "带权重的幸运转盘，共 3 个奖励等级。每 24 小时转一次。" },
      { title: "通行证", body: "史诗通行证或稀有通行证，自激活起 365 天有效。提供个人、家庭、团队和巴士团档位。" },
      { title: "特殊巨魔", body: "2 个周末限定巨魔（周五至周日）、10 个节日限定巨魔、6 个位于当地商家的商家巨魔，以及 5 个活动巨魔。" },
    ],
  },
  gallery: {
    kicker: "巨魔日志",
    title: "认识全部 84 个巨魔。",
    body: "每个巨魔都有名字、绰号和小怪癖。点击卡片，阅读它的日志。",
    chips: { all: "全部", common: "普通", rare: "稀有", epic: "史诗", legendary: "传说", festivals: "节日", merchants: "商家", weekend: "周末", promo: "活动" },
    more: "显示更多巨魔",
    count: "/ 84",
    portraitNote: "其余的还在躲藏——去应用里找到它们吧。",
    hidden: "仍在躲藏",
    hiding: "躲藏中",
  },
  journal: {
    entry: "日志",
    where: "位置",
    waterfall: "瀑布",
    xp: "经验值",
    access: "解锁方式",
    window: "出现时间",
    weekend: "仅限周五至周日",
    liveNow: "正在出没",
    catchIt: "在应用中捕捉",
  },
  access: { free: "永久免费", epic_pass: "史诗通行证", rare_pass: "稀有通行证" },
  rarity: { common: "普通", rare: "稀有", epic: "史诗", legendary: "传说" },
  category: { stream: "溪流巨魔", intro: "新手向导", merchant: "商家巨魔", promo: "活动巨魔", weekend: "周末巨魔", festival_sami: "萨米节日巨魔", festival_norwegian: "挪威节日巨魔" },
  specials: {
    kicker: "特殊巨魔",
    title: "19 个特殊巨魔——外加 5 个活动巨魔。",
    body: "有些巨魔有自己的日历。节日巨魔只在真实的节日日期出现。",
    flavours: [
      { key: "intro", count: 1, title: "新手向导", body: "你在 Lavangen 遇到的第一个巨魔——教你怎么玩。" },
      { key: "festival_sami", count: 4, title: "萨米节日巨魔", body: "萨米民族日、Riddu Riđđu 和 Márkomeannu。" },
      { key: "festival_norwegian", count: 6, title: "挪威节日巨魔", body: "从 5 月 17 日宪法日到极夜。" },
      { key: "weekend", count: 2, title: "周末巨魔", body: "只在周五至周日出没。" },
      { key: "merchant", count: 6, title: "商家巨魔", body: "住在沿途真实的当地商家里。" },
      { key: "promo", count: 5, title: "活动巨魔", body: "通过邀请好友、海报和优惠码解锁。" },
    ],
    calendar: "节日日历",
    next: "下一次",
    liveNow: "正在出没",
  },
  festivals: {
    "Sámi National Day": "萨米民族日", "Riddu Riđđu": "Riddu Riđđu 萨米文化节", "Márkomeannu": "Márkomeannu 萨米文化节",
    "Constitution Day": "挪威宪法日", "Midsummer": "仲夏节", "Lussinatta": "露西亚之夜",
    "Christmas": "圣诞节", "Midnight Sun": "午夜太阳", "Polar Night": "极夜",
  },
  seasons: {
    kicker: "四季",
    title: "同一条步道，四种截然不同的心情。",
    standout: "本季明星巨魔",
    tabs: {
      winter: { name: "冬", title: "极光下滑雪", body: "在北极光于峡湾上空起舞时，踩着越野滑雪板沿路滑行。戴好头灯，装满保温瓶。" },
      spring: { name: "春", title: "驯鹿复活节", body: "白昼漫长明亮，积雪清脆，驯鹿开始迁徙。平缓路段非常适合家庭出游。" },
      summer: { name: "夏", title: "午夜阳光下的篝火", body: "在平坦路段滑轮滑，让孩子们骑车冲在前面；当太阳迟迟不肯落下时，点起一堆篝火。" },
      autumn: { name: "秋", title: "采蘑菇徒步", body: "金色的白桦、蓝莓和鸡油菌。爷爷奶奶喜欢平缓路段——巨魔们也一样。" },
    },
  },
  merchants: {
    kicker: "当地商家",
    title: "商家巨魔住在真实的当地小店里。",
    body: "六个巨魔住在沿途的小屋、咖啡馆、商店和租赁点。免费捕捉它们，并在那里使用你的巨魔克朗。",
    partnerSoon: "合作商家将在上线时公布",
    spend: "可在此使用巨魔克朗",
    types: { "Cabin rental": "小屋出租", "Farm shop": "农场小店", "Café": "咖啡馆", "Kayak rental": "皮划艇出租", "Bakery": "面包店", "Grocer · finish line": "杂货店 · 终点" },
  },
  pricing: {
    kicker: "价格",
    title: "免费开始。想要更多？带上通行证。",
    launch: "首发价 · 2026 季全程 5 折",
    tiers: { person: "个人", family: "家庭", team: "团队", bus: "巴士团" },
    days: "自激活起 365 天有效",
    free: { name: "免费", price: "0 kr", line: "61 个巨魔永久免费", body: "无需注册。", perks: ["所有普通和稀有溪流巨魔", "全部 6 个商家巨魔", "新手向导 + 5 个活动巨魔"], cta: "免费开始" },
    epic: { name: "史诗通行证", line: "解锁史诗和传说巨魔", perks: ["所有史诗和传说溪流巨魔", "两个周末巨魔"], cta: "获取史诗通行证" },
    rare: { name: "稀有通行证", line: "解锁所有巨魔——包括节日和传说巨魔", perks: ["全部 84 个巨魔", "全部 10 个节日巨魔", "史诗通行证的全部内容"], cta: "获取稀有通行证", ribbon: "全部 84 个巨魔" },
    note: "通行证在应用内购买，价格单位为挪威克朗（kr）。首发价限时有效。",
    was: "原价",
  },
  faq: {
    kicker: "常见问题",
    title: "来自起点的提问。",
    items: [
      ["需要注册吗？", "不需要。下载应用，打开就能开始狩猎。61 个巨魔永久免费。"],
      ["步道沿线有手机信号吗？", "公路沿线的信号通常不错，但在山谷中个别地段可能变弱。出发前请充好手机电量，并记下紧急电话号码。"],
      ["冬天可以玩吗？", "可以。巨魔全年都在。请带上滑雪板或防滑鞋钉、极夜用的头灯，出发前查看路况。"],
      ["适合孩子吗？", "适合。很多巨魔就在公路附近，平缓路段适合小朋友、自行车和婴儿车。部分路线沿公共道路，请注意交通安全。"],
      ["在哪里停车？怎么返回？", "可以从 Lavangen 或 Årstein 出发。部分路段有地区巴士，出发前请查看当地时刻表。"],
      ["什么是商家巨魔？", "住在沿途真实当地商家（小屋、咖啡馆或商店）里的巨魔。免费捕捉，还可以在那里使用巨魔克朗。"],
      ["什么是巨魔克朗？", "应用内货币。通过邀请好友、每日转盘和商家巨魔获得，可在合作小屋和商家使用。"],
      ["节日日期准确吗？", "节日巨魔只在真实的节日日期内出现。如果节日改期，巨魔也会跟着改。"],
      ["通行证有效期多久？", "史诗和稀有通行证自激活之日起有效 365 天，提供个人、家庭、团队和巴士团档位。"],
      ["我的隐私如何保护？", "无需账户即可游玩。应用只在你游戏时使用位置来显示附近的巨魔。本网站不收集任何信息。"],
    ],
  },
  install: { title: "Trollfossjakten", body: "61 个巨魔永久免费", cta: "下载应用", dismiss: "关闭下载栏" },
  footer: { supporter: "成为支持者", about: "关于", press: "媒体", privacy: "隐私", terms: "条款", contact: "联系", follow: "关注我们的狩猎", soon: "上线时开放", country: "挪威", supportedBy: "支持单位" },
  logoAlt: "Trollfossjakten 标志",
  langSwitch: "语言",
  a11y: { menu: "菜单", footer: "页脚", zoomIn: "放大", zoomOut: "缩小", notifications: "通知" },
  sos: "紧急求助",
  emergency: {
    back: "返回",
    title: "紧急求助",
    alert: "如果你身处危险，请立即拨打当地紧急电话。",
    h1: "SOS——步道上任何地方都能快速求助。",
    intro: "点击号码即可拨打。可将你的实时位置（以及照片和留言）分享给家人、朋友或救援服务。",
    step: "第 {n} 步",
    country: "你所在的国家",
    search: "搜索国家…",
    noMatch: "没有匹配的国家",
    callNow: "立即拨打 —",
    all: "所有紧急情况",
    police: "警察",
    fire: "消防",
    ambulance: "急救",
    locTitle: "发送你的实时位置",
    detect: "获取我的位置",
    locating: "正在定位…",
    refresh: "刷新位置",
    noGeo: "你的浏览器不支持定位。",
    locFail: "无法获取你的位置。",
    near: "附近",
    openMaps: "在 Google 地图中打开 ↗",
    msgLabel: "添加留言（可选）",
    msgPh: "例如：我在第二座瀑布附近扭伤了脚踝。请带水和急救包。",
    photoLabel: "附加照片（可选）",
    choose: "选择照片",
    change: "更换照片",
    remove: "移除",
    previewAlt: "附加的照片",
    send: "发送紧急位置",
    copy: "复制",
    shared: "已通过你的设备分享。",
    shareFail: "无法打开分享菜单，请改用复制。",
    copied: "已复制。",
    copyFail: "复制失败。",
    privacy: "分享使用你手机自带的分享菜单（短信、WhatsApp、邮件等），不会经过我们的服务器。遇到真正的紧急情况时，请务必同时拨打上方的号码。",
    backTrail: "返回步道",
    msgHead: "🆘 紧急情况——我需要帮助。",
    mapLabel: "地图",
    timeLabel: "时间",
    shareTitle: "紧急求助 — Trollfossjakten",
    notes: {
      NO: "112 是欧洲通用紧急电话。110 直通消防，113 直通医疗急救。",
      SE: "所有紧急服务统一拨打 112。",
      FI: "112 可联系警察、消防和急救。",
      DK: "紧急情况拨打 112，非紧急报警拨打 114。",
      IS: "全国统一号码：112。",
      DE: "报警拨打 110，消防和急救拨打 112。",
      FR: "17 警察，18 消防，15 急救（SAMU）。112 也可拨打。",
      GB: "所有紧急情况拨打 999（或 112）。非紧急报警拨打 101。",
      IE: "112 和 999 均可拨打。",
      NL: "紧急情况拨打 112，非紧急报警拨打 0900-8844。",
      ES: "112 覆盖所有紧急服务。国家警察 091，地方警察 092。",
      IT: "所有紧急情况拨打 112，国家警察 113。",
      PL: "112 可联系所有紧急服务。",
      US: "任何紧急情况拨打 911。许多城市的非紧急事务拨打 311。",
      CA: "全国所有紧急情况拨打 911。",
      AU: "三个零（000）。手机也可拨打 112。",
      NZ: "全国拨打 111。非紧急报警拨打 105。",
      CN: "110 报警，119 火警，120 急救，122 交通事故。",
      RU: "112 可联系所有紧急服务。102 警察，101 消防，103 急救。",
      TH: "191 警察，199 消防，1669 急救。旅游警察 1155（可讲英语）。",
    },
  },
};

export default zh;
